import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, UserPlus } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const POSITIONS = ['Juez titular', 'Juez presidente', 'Juez suplente', 'Juez destinado', 'Administrador del tribunal'];

// Add a judge to a first-instance court (PJUD doesn't publish these rosters openly); Fidem profiles them automatically
export const AddJudgeForm = ({ slug, onAdded, testid = `add-judge-${slug}` }) => {
  const { api } = useAuth();
  const [name, setName] = useState('');
  const [position, setPosition] = useState(POSITIONS[0]);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post(`/courts/${slug}/members`, { name, position });
      toast.success(r.data.judge.existing ? 'Ya estaba en la nómina' : 'Juez agregado: Fidem está analizando su perfil');
      setName('');
      onAdded(r.data.judge);
    } catch (err) { toast.error(err.response?.data?.detail?.[0]?.msg || err.response?.data?.detail || 'No se pudo agregar'); } finally { setBusy(false); }
  };
  return (
    <form data-testid={testid} onSubmit={submit} className="mt-2 flex flex-wrap gap-1.5">
      <input data-testid={`${testid}-name`} value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre y apellidos del juez" className="min-w-[160px] flex-1 rounded-lg border border-slate-700 bg-slate-900 px-2 py-1 text-xs text-white outline-none focus:border-amber-500" />
      <select data-testid={`${testid}-position`} value={position} onChange={(e) => setPosition(e.target.value)} className="rounded-lg border border-slate-700 bg-slate-900 px-2 py-1 text-xs text-slate-200">
        {POSITIONS.map((p) => <option key={p}>{p}</option>)}
      </select>
      <button data-testid={`${testid}-submit`} disabled={busy || name.trim().split(/\s+/).length < 2} className="flex items-center gap-1 rounded-lg bg-amber-500 px-2.5 py-1 text-xs font-semibold text-slate-950 disabled:opacity-50">
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <UserPlus className="h-3 w-3" />}Agregar
      </button>
    </form>
  );
};
